export default __webpack_public_path__ + "static/media/server.b08867a2.svg";